import { HEALTH_AREA_FIELDS } from "@/graphql/shared";
import { gql, useQuery } from "@apollo/client";

const FILTERS_QUERY = gql`
  query FiltersQuery {
    sampleTypes
    testingServices
    categories: healthAreas {
      ...HealthAreaFields
    }
  }
  ${HEALTH_AREA_FIELDS}
`;

export default function useFilters() {
  const { data: { sampleTypes = [], testingServices = [], categories: _categories = [] } = {} } =
    useQuery(FILTERS_QUERY);

  return {
    sampleTypes,
    testingServices,
    categories: _categories.map(cat => cat.name)
  };
}
